import React from 'react';
import { BookOpen, Target, Wand2 } from 'lucide-react';

export function HowToUse() {
  const steps = [
    {
      icon: <Target className="w-6 h-6" />,
      title: "Enter Your Topic",
      description: "Input your main topic and target keyword to focus your headline generation"
    },
    {
      icon: <BookOpen className="w-6 h-6" />,
      title: "Choose Parameters",
      description: "Select your industry, audience level, and content goals"
    },
    {
      icon: <Wand2 className="w-6 h-6" />,
      title: "Generate Headlines",
      description: "Get instant access to engaging, SEO-optimized headline variations"
    }
  ];

  return (
    <section id="how-to-use" className="scroll-mt-16">
      <h2 className="text-3xl font-bold text-gray-900 text-center mb-12">How to Use Our Blog Title Generator</h2>
      <div className="grid md:grid-cols-3 gap-8">
        {steps.map((step, index) => (
          <div key={index} className="bg-white rounded-xl shadow-lg p-6 text-center">
            <div className="w-12 h-12 bg-indigo-100 rounded-full flex items-center justify-center mx-auto mb-4">
              {React.cloneElement(step.icon, { className: "w-6 h-6 text-indigo-600" })}
            </div>
            <h3 className="text-xl font-semibold mb-2">{step.title}</h3>
            <p className="text-gray-600">{step.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
}